import React from "react";

export default function Pagination({ page, totalPages, onChange }) {
  if (!totalPages || totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1
  );

  let last = 0;
  return (
    <div className="pm-pagination">
      <button disabled={page <= 1} onClick={() => onChange(page - 1)} className="pm-pagination__btn">
        Prev
      </button>
      {pages.map((p) => {
        const showEllipsis = p - last > 1;
        last = p;
        return (
          <React.Fragment key={p}>
            {showEllipsis && <span className="pm-pagination__dots">…</span>}
            <button
              onClick={() => onChange(p)}
              className={`pm-pagination__btn ${p === page ? "is-active" : ""}`}
            >
              {p}
            </button>
          </React.Fragment>
        );
      })}
      <button
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="pm-pagination__btn"
      >
        Next
      </button>
    </div>
  );
}
